import { cloneDeep, isArray, mergeWith } from 'lodash'
import { StateCreator } from 'zustand'

import { EOnboardingStepFriendlyNames } from '~/features/onboarding/models'
import {
  ESettingsStepFriendlyNames,
  TSettingsDefinitionSteps,
} from '~/features/settings/models'
import EStoreStateKeys from '~/models/store'

type TSettingsDefinition = {
  steps: Partial<TSettingsDefinitionSteps>
}

type TSettings = {
  [EStoreStateKeys.settings]: TSettingsDefinition
}

export type TSettingsState = TSettings & {
  setSettings(settings: Partial<TSettingsDefinition>): void
  resetSettings(): void
}

export const initialSettingsState: TSettingsDefinition = {
  steps: {
    [EOnboardingStepFriendlyNames.creatingLibby]: false,
    [ESettingsStepFriendlyNames.convoOptions]: null,
    [ESettingsStepFriendlyNames.knowledge]: null,
  },
}

const createSettingsSlice: StateCreator<
  TSettingsState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  settings: cloneDeep(initialSettingsState),
  setSettings: (settings) =>
    set(
      (state) => ({
        settings: mergeWith(
          cloneDeep(state.settings),
          settings,
          (objValue, srcValue) => {
            if (isArray(objValue)) {
              return srcValue
            }
            // eslint-disable-next-line consistent-return
            return undefined
          },
        ),
      }),
      undefined,
      {
        type: 'setSettings',
        settings,
      },
    ),

  resetSettings: () =>
    set(
      () => ({
        settings: cloneDeep(initialSettingsState),
      }),
      undefined,
      {
        type: 'resetSettings',
      },
    ),
})

export default createSettingsSlice
